//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
import PreEntryApi from '../assets/js/preentry'
// 使用说明：v-model时，必须传带有带有省，市，区拼音的字段

export default {
  name: 'li_area_home_select',
  // 通过 model 选项配置子组件接收的 prop 名以及派发的事件名
  model: {
    prop: 'caddress',
    event: 'change'
  },
  props: {
    caddress: Object
  },
  data () {
    return {
      areaJson: '../static/json/address.json',
      addressArray: [], // 所有数据
      cityArray: [],
      areaArray: [],
      select_current_address: {}
    }
  },
  created () {
    this.getAddressData()
  },
  methods: {
    getAddressData () {
      var that = this
      PreEntryApi.getCityInfoOfRedis(
         { },
      (response, meta) => {
        if (response.status === 200) {
          that.handleInfo(response)
        }
        if (response.status !== 200 || !response.data.data) {
          axios.get(that.areaJson).then(function (response) {
            if (response.status === 200) {
              that.handleInfo(response)
            }
          })
        }
      })
    },
    // 处理省市信息
    handleInfo (response) {
      var that = this
      that.addressArray = response.data.data
      // 默认值赋值获取城市数组
      if (that.caddress.sheng) {
        for (let ad of that.addressArray) {
          if (ad.areaname === that.caddress.sheng) {
            that.select_current_address.sheng_id = ad.id
            that.select_current_address.sheng_code = ad.areacode
            that.$emit('func', that.select_current_address)
            that.cityArray = ad.subarea
          // 默认赋值获取区域数组
            if (that.caddress.shi) {
              for (let area of that.cityArray) {
                if (area.areaname === that.caddress.shi) {
                  that.select_current_address.shi_id = area.id
                  that.select_current_address.sheng_code = area.areacode
                  that.$emit('func', that.select_current_address)
                  that.areaArray = area.subarea
                  break
                }
              }
            }
          }
        }
      }
    },
    // 选择省份
    getCityData (val) {
      // 清空市，和区
      this.caddress.shi = ''
      this.caddress.qu = ''
      this.select_current_address.shi_id = 0
      this.select_current_address.qu_id = 0
      this.areaArray = []
      this.$emit('change', this.caddress)// 发送改变
      for (let ad of this.addressArray) {
        if (ad.areaname === val) {
          this.select_current_address.sheng_id = ad.id
          this.select_current_address.sheng_code = ad.areacode
          this.cityArray = ad.subarea
          this.$emit('func', this.select_current_address)
          return
        }
      }
    },
    getAreaData (val) {
      // 清空区
      this.caddress.qu = ''
      this.select_current_address.qu_id = 0
      this.$emit('change', this.caddress)// 发送改变
      for (let area of this.cityArray) {
        if (area.areaname === val) {
          this.select_current_address.shi_id = area.id
          this.areaArray = area.subarea
          this.$emit('checkResidenceType')
          this.$emit('func', this.select_current_address)
          return
        }
      }
    },
    // 地区数据变动后
    onAreaChanged (val) {
      this.$emit('change', this.caddress)// 发送改变
      for (let area of this.areaArray) {
        if (area.areaname === val) {
          this.select_current_address.qu_id = area.id
          this.$emit('func', this.select_current_address)
          return
        }
      }
    },
    //
    getCaddress (val, val2) {
      this.caddress = val
      this.select_current_address = val2
      this.getAddressData()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/li_area_current_select.vue